// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusProposedChange_status__LaGVM {
  border-radius: 100px;
  font-size: 14px;
  font-weight: 700;
  line-height: 19.6px;
  padding: 2px 20px;
}
.StatusProposedChange_status__LaGVM.StatusProposedChange_pending__H9l4v {
  background-color: #ebe4d6;
  color: #c9a46d;
}`, "",{"version":3,"sources":["webpack://./src/pages/Operate/CNFollowCustomer/StatusProposedChange/StatusProposedChange.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,yBAAA;EACA,cAAA;AACJ","sourcesContent":[".status {\n  border-radius: 100px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19.6px;\n  padding: 2px 20px;\n\n  &.pending {\n    background-color: #ebe4d6;\n    color: #c9a46d;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `StatusProposedChange_status__LaGVM`,
	"pending": `StatusProposedChange_pending__H9l4v`
};
export default ___CSS_LOADER_EXPORT___;
